// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","footerNav":"App_footerNav__uiV5o"};